import {
  ParagraphText,
  StackLayout,
  TextAction,
} from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { EXTERNAL_LINKS } from "common/links";

export const SignInFooter = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout
      horizontalAlignment="center"
      css={{ position: "relative", marginBlockEnd: "$two", width: "100%" }}
    >
      <ParagraphText size="sm">
        <TextAction
          href={EXTERNAL_LINKS.PRIVACY}
          target="_blank"
          rel="noopener noreferrer"
          size="medium"
          css={{
            fontWeight: "$bodyTwo !important",
            textDecoration: "underline",
          }}
        >
          {formatMessage({ id: "STR_PRIVACY_POLICY" })}
        </TextAction>
        {` ${formatMessage({ id: "STR_AND" })} `}
        <TextAction
          href={EXTERNAL_LINKS.TERMS}
          target="_blank"
          rel="noopener noreferrer"
          size="medium"
          css={{
            fontWeight: "$bodyTwo !important",
            textDecoration: "underline",
          }}
        >
          {formatMessage({ id: "STR_TERMS_OF_SERVICE" })}
        </TextAction>
      </ParagraphText>
    </StackLayout>
  );
};
